export default __webpack_public_path__ + "static/media/img-4.c7a84ad5.jpg";